export const ServerEvent = {
    fromPartial<I extends Exact<DeepPartial<ServerEvent>, I>>(object: I): ServerEvent {
        const message = createBaseServerEvent();
        message.eventName = object.eventName ?? "";
        message.serverTs = object.serverTs ?? 0;
        message.userId = object.userId ?? "";
        message.userAgent = object.userAgent ?? "";
        message.country = object.country ?? "";
        message.city = object.city ?? "";
        message.region = object.region ?? "";
        message.eventId = object.eventId ?? "";
        message.instanceId = object.instanceId ?? "";
        message.sequenceId = object.sequenceId ?? 0;
        message.osType = object.osType ?? "";
        message.osVersion = object.osVersion ?? "";
        message.appVersion = object.appVersion ?? "";
        message.appBuild = object.appBuild ?? "";
        message.serverUploadTs = object.serverUploadTs ?? 0;
        message.eventTime = object.eventTime ?? 0;
        message.serverReceiptTime = object.serverReceiptTime ?? 0;
        message.maxSequenceIdOnInstance = object.maxSequenceIdOnInstance ?? 0;
        message.userGuid = object.userGuid ?? "";
        message.collection = object.collection ?? 0;
        message.serviceId = object.serviceId ?? "";
        message.appType = object.appType ?? 0;
        message.spectrumInstanceId = object.spectrumInstanceId ?? "";
        message.spectrumSequenceId = object.spectrumSequenceId ?? 0;
        message.eventData =
            object.eventData !== undefined && object.eventData !== null
                ? ServerEventData.fromPartial(object.eventData)
                : undefined;
        return message;
    },
};
export const ServerEventData = {
    fromPartial<I extends Exact<DeepPartial<ServerEventData>, I>>(object: I): ServerEventData {
        const message = createBaseServerEventData();
        message.cameraKitException =
            object.cameraKitException !== undefined && object.cameraKitException !== null
                ? CameraKitException.fromPartial(object.cameraKitException)
                : undefined;
        message.cameraKitLensSpin =
            object.cameraKitLensSpin !== undefined && object.cameraKitLensSpin !== null
                ? CameraKitLensSpin.fromPartial(object.cameraKitLensSpin)
                : undefined;
        message.cameraKitAssetDownload =
            object.cameraKitAssetDownload !== undefined && object.cameraKitAssetDownload !== null
                ? CameraKitAssetDownload.fromPartial(object.cameraKitAssetDownload)
                : undefined;
        message.cameraKitLensContentValidationFailed =
            object.cameraKitLensContentValidationFailed !== undefined && object.cameraKitLensContentValidationFailed !== null
                ? CameraKitLensContentValidationFailed.fromPartial(object.cameraKitLensContentValidationFailed)
                : undefined;
        message.cameraKitLensDownload =
            object.cameraKitLensDownload !== undefined && object.cameraKitLensDownload !== null
                ? CameraKitLensDownload.fromPartial(object.cameraKitLensDownload)
                : undefined;
        message.cameraKitAssetValidationFailed =
            object.cameraKitAssetValidationFailed !== undefined && object.cameraKitAssetValidationFailed !== null
                ? CameraKitAssetValidationFailed.fromPartial(object.cameraKitAssetValidationFailed)
                : undefined;
        message.cameraKitSession =
            object.cameraKitSession !== undefined && object.cameraKitSession !== null
                ? CameraKitSession.fromPartial(object.cameraKitSession)
                : undefined;
        message.cameraKitWebLensSwipe =
            object.cameraKitWebLensSwipe !== undefined && object.cameraKitWebLensSwipe !== null
                ? CameraKitWebLensSwipe.fromPartial(object.cameraKitWebLensSwipe)
                : undefined;
        message.cameraKitWebBenchmarkComplete =
            object.cameraKitWebBenchmarkComplete !== undefined && object.cameraKitWebBenchmarkComplete !== null
                ? CameraKitWebBenchmarkComplete.fromPartial(object.cameraKitWebBenchmarkComplete)
                : undefined;
        message.cameraKitLegalPrompt =
            object.cameraKitLegalPrompt !== undefined && object.cameraKitLegalPrompt !== null
                ? CameraKitLegalPrompt.fromPartial(object.cameraKitLegalPrompt)
                : undefined;
        return message;
    },
};
function createBaseServerEventData(): ServerEventData {
    return {
        cameraKitException: undefined,
        cameraKitLensSpin: undefined,
        cameraKitAssetDownload: undefined,
        cameraKitLensContentValidationFailed: undefined,
        cameraKitLensDownload: undefined,
        cameraKitAssetValidationFailed: undefined,
        cameraKitSession: undefined,
        cameraKitWebLensSwipe: undefined,
        cameraKitWebBenchmarkComplete: undefined,
        cameraKitLegalPrompt: undefined,
    };
}
function createBaseServerEvent(): ServerEvent {
    return {
        eventName: "",
        serverTs: 0,
        userId: "",
        userAgent: "",
        country: "",
        city: "",
        region: "",
        eventId: "",
        instanceId: "",
        sequenceId: 0,
        osType: "",
        osVersion: "",
        appVersion: "",
        appBuild: "",
        serverUploadTs: 0,
        eventTime: 0,
        serverReceiptTime: 0,
        maxSequenceIdOnInstance: 0,
        userGuid: "",
        collection: 0,
        serviceId: "",
        appType: 0,
        spectrumInstanceId: "",
        spectrumSequenceId: 0,
        eventData: undefined,
    };
}
export interface ServerEvent {
    eventName: string;
    serverTs: number;
    userId: string;
    userAgent: string;
    country: string;
    city: string;
    region: string;
    eventId: string;
    instanceId: string;
    sequenceId: number;
    osType: string;
    osVersion: string;
    appVersion: string;
    appBuild: string;
    serverUploadTs: number;
    eventTime: number;
    serverReceiptTime: number;
    maxSequenceIdOnInstance: number;
    userGuid: string;
    collection: Collection;
    serviceId: string;
    appType: AppType;
    spectrumInstanceId: string;
    spectrumSequenceId: number;
    eventData: ServerEventData | undefined;
}
export interface ServerEventData {
    cameraKitException: CameraKitException | undefined;
    cameraKitLensSpin: CameraKitLensSpin | undefined;
    cameraKitAssetDownload: CameraKitAssetDownload | undefined;
    cameraKitLensContentValidationFailed: CameraKitLensContentValidationFailed | undefined;
    cameraKitLensDownload: CameraKitLensDownload | undefined;
    cameraKitAssetValidationFailed: CameraKitAssetValidationFailed | undefined;
    cameraKitSession: CameraKitSession | undefined;
    cameraKitWebLensSwipe: CameraKitWebLensSwipe | undefined;
    cameraKitWebBenchmarkComplete: CameraKitWebBenchmarkComplete | undefined;
    cameraKitLegalPrompt: CameraKitLegalPrompt | undefined;
}
export enum AppType {
    IOS_NATIVE = 0,
    IOS_WEB_DESKTOP = 1,
    IOS_WEB_MOBILE = 2,
    ANDROID_NATIVE = 3,
    ANDROID_WEB_DESKTOP = 4,
    ANDROID_WEB_MOBILE = 5,
    OSX_WEB_DESKTOP = 6,
    OSX_WEB_MOBILE = 7,
    WINDOWS_WEB_DESKTOP = 8,
    WINDOWS_WEB_MOBILE = 9,
    LINUX_WEB_DESKTOP = 10,
    LINUX_WEB_MOBILE = 11,
    LENSSTUDIO = 12,
    SNAPCAMERA = 13,
    WEB_DESKTOP = 14,
    WEB_MOBILE = 15,
    LENSSTUDIO_REMAKE = 16,
    UNRECOGNIZED = -1
}
export enum Collection {
    COLLECTION_UNUSED = 0,
    GAE = 1,
    GCE_M = 2,
    GCE_S = 3,
    GCE_T = 4,
    GKE_M = 5,
    GKE_S = 6,
    GKE_T = 7,
    LOCAL = 8,
    GCE_ST = 9,
    GKE_ST = 10,
    GCE_C = 11,
    GCE_SC = 12,
    GCE_TC = 13,
    GCE_TSC = 14,
    GKE_C = 15,
    GKE_SC = 16,
    GKE_TC = 17,
    GKE_TSC = 18,
    GKE_W = 19,
    GKE_WT = 20,
    GKE_WC = 21,
    GKE_WSC = 22,
    UNRECOGNIZED = -1
}
export const CameraKitLensSpin = {
    fromPartial<I extends Exact<DeepPartial<CameraKitLensSpin>, I>>(object: I): CameraKitLensSpin {
        const message = createBaseCameraKitLensSpin();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.lensId = object.lensId ?? "";
        message.viewTimeSec = object.viewTimeSec ?? 0;
        message.lensGroupId = object.lensGroupId ?? "";
        return message;
    },
};
function createBaseCameraKitLensSpin(): CameraKitLensSpin {
    return { cameraKitEventBase: undefined, lensId: "", viewTimeSec: 0, lensGroupId: "" };
}
export interface CameraKitLensSpin {
    cameraKitEventBase: CameraKitEventBase | undefined;
    lensId: string;
    viewTimeSec: number;
    lensGroupId: string;
}
export const CameraKitWebLensSwipe = {
    fromPartial<I extends Exact<DeepPartial<CameraKitWebLensSwipe>, I>>(object: I): CameraKitWebLensSwipe {
        const message = createBaseCameraKitWebLensSwipe();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.performanceCluster = object.performanceCluster ?? 0;
        message.webglRendererInfo = object.webglRendererInfo ?? "";
        message.lensId = object.lensId ?? "";
        message.lensFrameProcessingTimeMsAvg = object.lensFrameProcessingTimeMsAvg ?? 0;
        message.lensFrameProcessingTimeMsStd = object.lensFrameProcessingTimeMsStd ?? 0;
        message.viewTimeSec = object.viewTimeSec ?? 0;
        message.recordingTimeSec = object.recordingTimeSec ?? 0;
        message.applyDelaySec = object.applyDelaySec ?? 0;
        message.avgFps = object.avgFps ?? 0;
        message.isLensFirstWithinDay = object.isLensFirstWithinDay ?? false;
        message.isLensFirstWithinMonth = object.isLensFirstWithinMonth ?? false;
        message.lensGroupId = object.lensGroupId ?? "";
        return message;
    },
};
function createBaseCameraKitWebLensSwipe(): CameraKitWebLensSwipe {
    return {
        cameraKitEventBase: undefined,
        performanceCluster: 0,
        webglRendererInfo: "",
        lensId: "",
        lensFrameProcessingTimeMsAvg: 0,
        lensFrameProcessingTimeMsStd: 0,
        viewTimeSec: 0,
        recordingTimeSec: 0,
        applyDelaySec: 0,
        avgFps: 0,
        isLensFirstWithinDay: false,
        isLensFirstWithinMonth: false,
        lensGroupId: "",
    };
}
export interface CameraKitWebLensSwipe {
    cameraKitEventBase: CameraKitEventBase | undefined;
    performanceCluster: number;
    webglRendererInfo: string;
    lensId: string;
    lensFrameProcessingTimeMsAvg: number;
    lensFrameProcessingTimeMsStd: number;
    viewTimeSec: number;
    recordingTimeSec: number;
    applyDelaySec: number;
    avgFps: number;
    isLensFirstWithinDay: boolean;
    isLensFirstWithinMonth: boolean;
    lensGroupId: string;
}
export const CameraKitLensDownload = {
    fromPartial<I extends Exact<DeepPartial<CameraKitLensDownload>, I>>(object: I): CameraKitLensDownload {
        const message = createBaseCameraKitLensDownload();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.lensId = object.lensId ?? "";
        message.automaticDownload = object.automaticDownload ?? false;
        message.downloadTimeSec = object.downloadTimeSec ?? 0;
        message.sizeByte = object.sizeByte ?? 0;
        return message;
    },
};
function createBaseCameraKitLensDownload(): CameraKitLensDownload {
    return { cameraKitEventBase: undefined, lensId: "", automaticDownload: false, downloadTimeSec: 0, sizeByte: 0 };
}
export interface CameraKitLensDownload {
    cameraKitEventBase: CameraKitEventBase | undefined;
    lensId: string;
    automaticDownload: boolean;
    downloadTimeSec: number;
    sizeByte: number;
}
export const CameraKitAssetDownload = {
    fromPartial<I extends Exact<DeepPartial<CameraKitAssetDownload>, I>>(object: I): CameraKitAssetDownload {
        const message = createBaseCameraKitAssetDownload();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.automaticDownload = object.automaticDownload ?? false;
        message.downloadTimeSec = object.downloadTimeSec ?? 0;
        message.sizeByte = object.sizeByte ?? 0;
        message.assetId = object.assetId ?? "";
        return message;
    },
};
function createBaseCameraKitAssetDownload(): CameraKitAssetDownload {
    return { cameraKitEventBase: undefined, automaticDownload: false, downloadTimeSec: 0, sizeByte: 0, assetId: "" };
}
export interface CameraKitAssetDownload {
    cameraKitEventBase: CameraKitEventBase | undefined;
    automaticDownload: boolean;
    downloadTimeSec: number;
    sizeByte: number;
    assetId: string;
}
export const CameraKitException = {
    fromPartial<I extends Exact<DeepPartial<CameraKitException>, I>>(object: I): CameraKitException {
        const message = createBaseCameraKitException();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.lensId = object.lensId ?? "";
        message.type = object.type ?? "";
        message.reason = object.reason ?? "";
        return message;
    },
};
function createBaseCameraKitException(): CameraKitException {
    return { cameraKitEventBase: undefined, lensId: "", type: "", reason: "" };
}
export interface CameraKitException {
    cameraKitEventBase: CameraKitEventBase | undefined;
    lensId: string;
    type: string;
    reason: string;
}
export const CameraKitSession = {
    fromPartial<I extends Exact<DeepPartial<CameraKitSession>, I>>(object: I): CameraKitSession {
        const message = createBaseCameraKitSession();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.dailySessionBucket = object.dailySessionBucket ?? 0;
        message.isFirstWithinMonth = object.isFirstWithinMonth ?? false;
        message.day = object.day ?? 0;
        message.month = object.month ?? 0;
        message.year = object.year ?? 0;
        return message;
    },
};
function createBaseCameraKitSession(): CameraKitSession {
    return { cameraKitEventBase: undefined, dailySessionBucket: 0, isFirstWithinMonth: false, day: 0, month: 0, year: 0 };
}
export interface CameraKitSession {
    cameraKitEventBase: CameraKitEventBase | undefined;
    dailySessionBucket: DailySessionBucket;
    isFirstWithinMonth: boolean;
    day: number;
    month: number;
    year: number;
}
export enum DailySessionBucket {
    NO_SESSION_BUCKET = 0,
    ONE_SESSION = 1,
    TWO_SESSION = 2,
    THREE_SESSION = 3,
    FOUR_SESSION = 4,
    FIVE_SESSION = 5,
    SIX_SESSION = 6,
    SEVEN_SESSION = 7,
    EIGHT_SESSION = 8,
    NINE_SESSION = 9,
    TEN_OR_MORE_SESSION = 10,
    UNRECOGNIZED = -1
}
export const CameraKitLensContentValidationFailed = {
    fromPartial<I extends Exact<DeepPartial<CameraKitLensContentValidationFailed>, I>>(object: I): CameraKitLensContentValidationFailed {
        const message = createBaseCameraKitLensContentValidationFailed();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.lensId = object.lensId ?? "";
        return message;
    },
};
function createBaseCameraKitLensContentValidationFailed(): CameraKitLensContentValidationFailed {
    return { cameraKitEventBase: undefined, lensId: "" };
}
export interface CameraKitLensContentValidationFailed {
    cameraKitEventBase: CameraKitEventBase | undefined;
    lensId: string;
}
export const CameraKitAssetValidationFailed = {
    fromPartial<I extends Exact<DeepPartial<CameraKitAssetValidationFailed>, I>>(object: I): CameraKitAssetValidationFailed {
        const message = createBaseCameraKitAssetValidationFailed();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.assetId = object.assetId ?? "";
        return message;
    },
};
function createBaseCameraKitAssetValidationFailed(): CameraKitAssetValidationFailed {
    return { cameraKitEventBase: undefined, assetId: "" };
}
export interface CameraKitAssetValidationFailed {
    cameraKitEventBase: CameraKitEventBase | undefined;
    assetId: string;
}
export const CameraKitWebBenchmarkComplete = {
    fromPartial<I extends Exact<DeepPartial<CameraKitWebBenchmarkComplete>, I>>(object: I): CameraKitWebBenchmarkComplete {
        const message = createBaseCameraKitWebBenchmarkComplete();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.benchmarkName = object.benchmarkName ?? "";
        message.benchmarkValue = object.benchmarkValue ?? 0;
        message.performanceCluster = object.performanceCluster ?? 0;
        message.webglRendererInfo = object.webglRendererInfo ?? "";
        return message;
    },
};
function createBaseCameraKitWebBenchmarkComplete(): CameraKitWebBenchmarkComplete {
    return {
        cameraKitEventBase: undefined,
        benchmarkName: "",
        benchmarkValue: 0,
        performanceCluster: 0,
        webglRendererInfo: "",
    };
}
export interface CameraKitWebBenchmarkComplete {
    cameraKitEventBase: CameraKitEventBase | undefined;
    benchmarkName: string;
    benchmarkValue: number;
    performanceCluster: number;
    webglRendererInfo: string;
}
export const CameraKitLegalPrompt = {
    fromPartial<I extends Exact<DeepPartial<CameraKitLegalPrompt>, I>>(object: I): CameraKitLegalPrompt {
        const message = createBaseCameraKitLegalPrompt();
        message.cameraKitEventBase =
            object.cameraKitEventBase !== undefined && object.cameraKitEventBase !== null
                ? CameraKitEventBase.fromPartial(object.cameraKitEventBase)
                : undefined;
        message.legalPromptId = object.legalPromptId ?? "";
        message.legalPromptResult = object.legalPromptResult ?? 0;
        return message;
    },
};
export const CameraKitEventBase = {
    fromPartial<I extends Exact<DeepPartial<CameraKitEventBase>, I>>(object: I): CameraKitEventBase {
        const message = createBaseCameraKitEventBase();
        message.kitEventBase =
            object.kitEventBase !== undefined && object.kitEventBase !== null
                ? KitEventBase.fromPartial(object.kitEventBase)
                : undefined;
        message.deviceCluster = object.deviceCluster ?? 0;
        message.cameraKitVersion = object.cameraKitVersion ?? "";
        message.lensCoreVersion = object.lensCoreVersion ?? "";
        message.deviceModel = object.deviceModel ?? "";
        message.cameraKitVariant = object.cameraKitVariant ?? 0;
        message.cameraKitFlavor = object.cameraKitFlavor ?? 0;
        message.appId = object.appId ?? "";
        message.deviceConnectivity = object.deviceConnectivity ?? 0;
        message.sessionId = object.sessionId ?? "";
        message.appVendorUuid = object.appVendorUuid ?? "";
        message.rankingRequestId = object.rankingRequestId ?? "";
        message.cameraKitEnvironment = object.cameraKitEnvironment ?? 0;
        message.partnerUuid = object.partnerUuid ?? "";
        return message;
    },
};
export const KitEventBase = {
    fromPartial<I extends Exact<DeepPartial<KitEventBase>, I>>(object: I): KitEventBase {
        const message = createBaseKitEventBase();
        message.oauthClientId = object.oauthClientId ?? "";
        message.locale = object.locale ?? "";
        message.kitUserAgent = object.kitUserAgent ?? "";
        message.ipAddress = object.ipAddress ?? "";
        message.osMinorVersion = object.osMinorVersion ?? "";
        message.kitVariant = object.kitVariant ?? 0;
        message.kitVariantVersion = object.kitVariantVersion ?? "";
        message.kitClientTimestampMillis = object.kitClientTimestampMillis ?? 0;
        message.clientSequenceId = object.clientSequenceId ?? 0;
        message.maxClientSequenceIdOnInstance = object.maxClientSequenceIdOnInstance ?? 0;
        message.targetArchitecture = object.targetArchitecture ?? "";
        message.runningWithDebuggerAttached = object.runningWithDebuggerAttached ?? false;
        message.runningInTests = object.runningInTests ?? false;
        message.runningInSimulator = object.runningInSimulator ?? false;
        message.isAppPrerelease = object.isAppPrerelease ?? false;
        message.kitAppId = object.kitAppId ?? "";
        message.kitSessionId = object.kitSessionId ?? "";
        message.kitPluginType = object.kitPluginType ?? 0;
        message.isFromReactNativePlugin = object.isFromReactNativePlugin ?? false;
        return message;
    },
};
function createBaseKitEventBase(): KitEventBase {
    return {
        oauthClientId: "",
        locale: "",
        kitUserAgent: "",
        ipAddress: "",
        osMinorVersion: "",
        kitVariant: 0,
        kitVariantVersion: "",
        kitClientTimestampMillis: 0,
        clientSequenceId: 0,
        maxClientSequenceIdOnInstance: 0,
        targetArchitecture: "",
        runningWithDebuggerAttached: false,
        runningInTests: false,
        runningInSimulator: false,
        isAppPrerelease: false,
        kitAppId: "",
        kitSessionId: "",
        kitPluginType: 0,
        isFromReactNativePlugin: false,
    };
}
function createBaseCameraKitEventBase(): CameraKitEventBase {
    return {
        kitEventBase: undefined,
        deviceCluster: 0,
        cameraKitVersion: "",
        lensCoreVersion: "",
        deviceModel: "",
        cameraKitVariant: 0,
        cameraKitFlavor: 0,
        appId: "",
        deviceConnectivity: 0,
        sessionId: "",
        appVendorUuid: "",
        rankingRequestId: "",
        cameraKitEnvironment: 0,
        partnerUuid: "",
    };
}
function createBaseCameraKitLegalPrompt(): CameraKitLegalPrompt {
    return { cameraKitEventBase: undefined, legalPromptId: "", legalPromptResult: 0 };
}
export interface CameraKitLegalPrompt {
    cameraKitEventBase: CameraKitEventBase | undefined;
    legalPromptId: string;
    legalPromptResult: CameraKitLegalPromptResult;
}
export enum CameraKitLegalPromptResult {
    CAMERA_KIT_LEGAL_PROMPT_MISSING = 0,
    CAMERA_KIT_LEGAL_PROMPT_ACCEPTED = 1,
    CAMERA_KIT_LEGAL_PROMPT_DISMISSED = 2,
    UNRECOGNIZED = -1
}
export interface CameraKitEventBase {
    kitEventBase: KitEventBase | undefined;
    deviceCluster: number;
    cameraKitVersion: string;
    lensCoreVersion: string;
    deviceModel: string;
    cameraKitVariant: CameraKitVariant;
    cameraKitFlavor: CameraKitFlavor;
    appId: string;
    deviceConnectivity: CameraKitConnectivityType;
    sessionId: string;
    appVendorUuid: string;
    rankingRequestId: string;
    cameraKitEnvironment: CameraKitEnvironment;
    partnerUuid: string;
}
export enum CameraKitEnvironment {
    CAMERA_KIT_ENVIRONMENT_UNKNOWN = 0,
    CAMERA_KIT_ENVIRONMENT_STAGING = 1,
    CAMERA_KIT_ENVIRONMENT_PRODUCTION = 2,
    UNRECOGNIZED = -1
}
export enum CameraKitConnectivityType {
    CAMERA_KIT_CONNECTIVITY_TYPE_UNKNOWN = 0,
    CAMERA_KIT_CONNECTIVITY_TYPE_WIFI = 1,
    CAMERA_KIT_CONNECTIVITY_TYPE_MOBILE = 2,
    CAMERA_KIT_CONNECTIVITY_TYPE_UNREACHABLE = 3,
    CAMERA_KIT_CONNECTIVITY_TYPE_BLUETOOTH = 4,
    UNRECOGNIZED = -1
}
export enum CameraKitFlavor {
    CAMERA_KIT_FLAVOR_UNKNOWN = 0,
    CAMERA_KIT_FLAVOR_DEBUG = 1,
    CAMERA_KIT_FLAVOR_RELEASE = 2,
    UNRECOGNIZED = -1
}
export enum CameraKitVariant {
    CAMERA_KIT_VARIANT_UNKNOWN = 0,
    CAMERA_KIT_VARIANT_PARTNER = 1,
    CAMERA_KIT_VARIANT_PUBLIC = 2,
    UNRECOGNIZED = -1
}
export interface KitEventBase {
    oauthClientId: string;
    locale: string;
    kitUserAgent: string;
    ipAddress: string;
    osMinorVersion: string;
    kitVariant: KitType;
    kitVariantVersion: string;
    kitClientTimestampMillis: number;
    clientSequenceId: number;
    maxClientSequenceIdOnInstance: number;
    targetArchitecture: string;
    runningWithDebuggerAttached: boolean;
    runningInTests: boolean;
    runningInSimulator: boolean;
    isAppPrerelease: boolean;
    kitAppId: string;
    kitSessionId: string;
    kitPluginType: KitPluginType;
    isFromReactNativePlugin: boolean;
}
export enum KitPluginType {
    NO_PLUGIN = 0,
    UNITY = 1,
    UNRECOGNIZED = -1
}
export enum KitType {
    UNKNOWN_KIT_TYPE = 0,
    BITMOJI_KIT = 1,
    CREATIVE_KIT = 2,
    LOGIN_KIT = 3,
    STORY_KIT = 4,
    CAMERA_KIT = 5,
    SHOP_KIT = 6,
    EULA_KIT = 7,
    PAYMENTS_KIT = 8,
    INVITE_KIT = 9,
    CAMERA_KIT_WEB = 10,
    UNRECOGNIZED = -1
}
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
